
































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { SubTransactionTypesModule } from '@/store/Products/SubTransactionTypesModule';
import { GeneralLedgerAccountsModule } from '@/store/Accounting/GeneralLedgerAccountsModule';
import CreateGeneralLedgerMappingOverridesRequest from '@/models/Products/ProductGeneralLedgerMapping/CreateGeneralLedgerMappingOverridesRequest';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'MappingOverridesCreateDialog' })
export default class extends SaascadaVueDialog {

    dialog = false;
    request: CreateGeneralLedgerMappingOverridesRequest = new CreateGeneralLedgerMappingOverridesRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new CreateGeneralLedgerMappingOverridesRequest();
            await SubTransactionTypesModule.getSubTransactionTypes();
            await GeneralLedgerAccountsModule.getGeneralLedgerAccountsForDialog();
        }
    }

    get transactionTypeOptions() {
        return ListUtils.transactionTypeOptions();
    }

    get subTransactionTypeOptions() {
        return SubTransactionTypesModule.subTransactionTypes;
    }

    get generalLedgerOptions() {
        return GeneralLedgerAccountsModule.generalLedgerAccountsForDialog;
    }

    async create() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            // Set the other fields with default values
            this.request.generalLedgerAccountMappingId = ProductDetailsModule.generalLedgerMappings.id;
            this.request.state = 'ACTIVE';

            await ProductDetailsModule.createGeneralLedgerMappingOverrides(this.request);
        }
    }

}
